import { defineMessages } from 'react-intl';

export const workStyleChoiceMessages = defineMessages({
	header: {
		id: 'WorkStyleChoice.header',
		defaultMessage: 'Set up how your team works',
		description: 'Heading of the signup screen where the user picks how their team plans work',
	},
	subheader: {
		id: 'WorkStyleChoice.subheader',
		defaultMessage: 'This is a starting point. You can change it anytime.',
		description: 'Sub-heading of the signup screen where the user picks how their team plans work',
	},
	cardsLabel: {
		id: 'WorkStyleChoice.cardsLabel',
		defaultMessage: 'Ways of working',
		description:
			'Screen reader label for the group of cards the user picks one way of working from',
	},
	sprintsTitle: {
		id: 'WorkStyleChoice.sprints.title',
		defaultMessage: 'Plan in sprints',
		description: 'Title of the card that sets up a scrum project with sprints',
	},
	sprintsDescription: {
		id: 'WorkStyleChoice.sprints.description',
		defaultMessage: 'Work in set cycles, like 2 weeks',
		description: 'Description of the card that sets up a scrum project with sprints',
	},
	flowTitle: {
		id: 'WorkStyleChoice.flow.title',
		defaultMessage: 'Track work as it flows',
		description: 'Title of the card that sets up a kanban project',
	},
	flowDescription: {
		id: 'WorkStyleChoice.flow.description',
		defaultMessage: 'Work continuously, with no set cycles',
		description: 'Description of the card that sets up a kanban project',
	},
	back: {
		id: 'WorkStyleChoice.backButton',
		defaultMessage: 'Back',
		description: 'Button on the work style signup screen that goes back to the team type screen',
	},
	continue: {
		id: 'WorkStyleChoice.continueButton',
		defaultMessage: 'Continue',
		description: 'Button that confirms the selected way of working and continues signup',
	},
});
